import useIntegrations from '@hooks/useIntegrations'

import type { AgencyModel } from '@models/types'

import IntegrationModule from './IntegrationModule'

interface IntegrationPlatformProps {
  agency: AgencyModel,
  serviceProvider: string,
}

const IntegrationPlatform = (props: IntegrationPlatformProps) => {
  const { agency, serviceProvider } = props

  const integrationPayload = useIntegrations({
    filters: {
      integrable_id: agency.id,
      integrable_type: 'Agency',
      service_provider: serviceProvider,
    },
  })

  const { filteredIntegrations } = integrationPayload

  return (
    filteredIntegrations.map(integration => (
      <IntegrationModule
        key={integration.id}
        agency={agency}
        integration={integration}
      />
    ))
  )
}

export default IntegrationPlatform
